import {Transporteur} from '@/models';

export default [
	{
		path: '/transporteurs',
		name: 'transporteurs',
		meta: {
			title: 'Liste des transporteurs',
			granted: [ 'API_GET_TRANSPORTEUR' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Transporteur.vue')
	},
	{
		path: '/transporteur/show/:id',
		name: 'transporteur-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Transporteur/Show.vue'),
				class: Transporteur
			}),
			editRoute: { name: 'transporteur-edit' },
		},
		meta: {
			title: 'Détail d\'un transporteur',
			granted: [ 'API_GET_TRANSPORTEUR' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/transporteur/edit/:id',
		name: 'transporteur-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Transporteur/Edit.vue'),
				class: Transporteur
			}),
		},
		meta: {
			title: 'Edition d\'un transporteur',
			granted: [ 'API_PUT_TRANSPORTEUR' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
